import React from "react";
import { StyledInboxPage, StyledReply } from "./styles";
import {
  BottomNav,
  ErrorScreen,
  FlexDiv,
  Header,
  LoaderComponent,
} from "../../components/";
import assets from "../../assets/";
import { useNavigate } from "react-router-dom";
import { useReservationDetails, useReservations } from "../../hooks/";
import { Reservation } from "../../types/reservation";
import { MessagesVector } from "../../assets/animations/MessagesAnimation";
import { useBookingEngine } from "../../context/BookingEngineContext";

type ReservationsResponse = {
  items: Reservation[];
  pagination: {
    page: number;
    items_per_page: number;
    total_items: number;
  };
};

const ReplySpan = ({ reservationId }: { reservationId: string }) => {
  const { reservation: reservationDetails } =
    useReservationDetails(reservationId);

  if (!reservationDetails || !reservationDetails.reservationMessageThreads) {
    return null;
  }

  for (let thread of reservationDetails.reservationMessageThreads) {
    const messages = thread.messages;
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
      if (!lastMessage.incoming) {
        return (
          <StyledReply>
            <img
              src={assets.ReplyVector}
              alt=""
              height={12}
              style={{ marginRight: 2 }}
            />{" "}
            Reply
          </StyledReply>
        );
      }
    }
  }

  return null;
};

const InboxScreen = () => {
  const navigate = useNavigate();
  const { reservations, loading, error } = useReservations();
  const { bookingEngineData } = useBookingEngine();

  if (loading) {
    return (
      <LoaderComponent content="Messages loading ...">
        {" "}
        <MessagesVector
          style={{
            filter: bookingEngineData ? "grayscale(0)" : "grayscale(0)",
          }}
        />
      </LoaderComponent>
    );
  }

  if (error)
    return (
      <ErrorScreen
        content={"An error happened.Try again"}
        imageSrc={assets.NoResultsVector}
      />
    );

  const reservationsList =
    (reservations as unknown as ReservationsResponse)?.items || [];

  reservationsList.sort((a: Reservation, b: Reservation) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });

  const handleReservationClick = (reservationId: string) => {
    navigate(`/inbox/${reservationId}`);
  };

  const getListingTitle = (reservation: Reservation) => {
    const allocatedUnit = reservation.allocatedUnits?.[0]; // Using optional chaining
    console.log("unit name", allocatedUnit);
    return allocatedUnit?.listingTitle || allocatedUnit?.name;
  };

  const getMainImage = (reservation: Reservation) => {
    const allocatedUnit = reservation.allocatedUnits?.[0]; // Using optional chaining
    return allocatedUnit?.mainImage?.image?.urls?.big || assets.NoResultsVector;
  };

  const getNumOfNights = (reservation: Reservation) => {
    return Math.floor(
      (Date.parse(reservation.toDate) - Date.parse(reservation.fromDate)) /
        86400000
    );
  };

  if (reservationsList.length === 0) {
    return (
      <StyledInboxPage>
        <h1>Your inbox is empty!</h1>
        <img
          height={400}
          src={assets.DissapointmentVector}
          alt="No messages in the inbox. "
        />
        <p style={{ width: "70%", textAlign: "center" }}>
          No messages in your inbox, yet.
        </p>
        <BottomNav />
      </StyledInboxPage>
    );
  }
  return (
    <StyledInboxPage>
      <Header />

      <div className="vertical-display">
        {" "}
        {reservationsList.length > 0 &&
          reservationsList.map((reservation: Reservation) => (
            <div
              className="inbox-card"
              key={reservation.uid}
              onClick={() => handleReservationClick(reservation.uid)}
            >
              <img
                className="unit-img"
                alt=""
                height={50}
                width={50}
                src={getMainImage(reservation)}
              />

              <div className="inbox-inner-card">
                <h4>{getListingTitle(reservation)}</h4>
                <FlexDiv alignitems="center" justifycontent="space-between">
                  {" "}
                  <span>
                    <span style={{ marginRight: 4 }}>🌙</span>{" "}
                    {getNumOfNights(reservation)}{" "}
                    {getNumOfNights(reservation) === 1 ? "night" : "nights"}
                  </span>
                  <ReplySpan reservationId={reservation.uid} />
                </FlexDiv>
              </div>
            </div>
          ))}
      </div>
      <BottomNav />
    </StyledInboxPage>
  );
};

export default InboxScreen;
